import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { TransactionDto, TransactionReceiptDto } from '../dtos';
import { TransactionFlowType } from '../enums/transaction-flow-type.enum';
import { TransactionProduct } from '../models';

export enum TransactionActionTypes {
  AddProductInTransaction = '[Transaction] AddProductInTransaction',
  RemoveProductFromTransaction = '[Transaction] RemoveProductFromTransaction',
  RemoveTransaction = '[Transaction] RemoveTransaction',
  RemoveAllProductsFromTransaction = '[Transaction] RemoveAllProductsFromTransaction',
  CreateTransaction = '[Transaction] CreateTransaction',
  SubmitTransaction = '[Transaction] SubmitTransaction',
  SubmitTransactionSuccess = '[Transaction] SubmitTransactionSuccess',
  SubmitTransactionError = '[Transaction] SubmitTransactionError',
  clearTransactionInformation = '[Transaction] ClearTransactionFlow',
  loadTransactionReceiptAction = '[Transaction] LoadTransactionReceipt',
  loadTransactionReceiptSuccessAction = '[Transaction] LoadTransactionReceiptSuccess',
  loadTransactionReceiptErrorAction = '[Transaction] LoadTransactionReceiptError',
  clearTransactionReceiptAction = '[Transaction] ClearTransactionReceiptAction',
}

export const addProductInTransactionAction = createAction(
  TransactionActionTypes.AddProductInTransaction,
  props<{ product: TransactionProduct }>()
);
export const removeProductFromTransactionAction = createAction(
  TransactionActionTypes.RemoveProductFromTransaction,
  props<{ productLineNo: number }>()
);
export const removeTransactionAction = createAction(TransactionActionTypes.RemoveTransaction);
export const removeAllProductsFromTransactionAction = createAction(
  TransactionActionTypes.RemoveAllProductsFromTransaction,
  props<{ transactionFlowType: TransactionFlowType }>()
);
export const createTransactionAction = createAction(
  TransactionActionTypes.CreateTransaction,
  props<{ paymentCardId: number; transactionFlow: TransactionFlowType }>()
);
export const submitTransactionAction = createAction(
  TransactionActionTypes.SubmitTransaction,
  props<{ transaction: TransactionDto; paymentCardId: number }>()
);
export const submitTransactionSuccessAction = createAction(
  TransactionActionTypes.SubmitTransactionSuccess,
  props<{ wordOfTheDay: string }>()
);
export const submitTransactionErrorAction = createAction(
  TransactionActionTypes.SubmitTransactionError,
  props<{ failure: AppStateFailure }>()
);
export const clearTransactionInformationAction = createAction(TransactionActionTypes.clearTransactionInformation);

export const loadTransactionReceiptAction = createAction(
  TransactionActionTypes.loadTransactionReceiptAction,
  props<{ transactionId: number }>()
);
export const loadTransactionReceiptSuccessAction = createAction(
  TransactionActionTypes.loadTransactionReceiptSuccessAction,
  props<{ transactionReceipt: TransactionReceiptDto }>()
);
export const loadTransactionReceiptErrorAction = createAction(
  TransactionActionTypes.loadTransactionReceiptErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const clearTransactionReceiptAction = createAction(TransactionActionTypes.clearTransactionReceiptAction);
